


























































import Vue from 'vue';
import { TokenReAuth } from '@/components/page-components';
import { MemberPersonalInformationResponseModel } from '@/@types/member';

interface Data {
  showErrorModal: boolean;
  loading: boolean;
  content: boolean;
  tokenModal: boolean;
}

export default Vue.extend({
  name: 'ErrorModal',
  props: {
    params: {
      type: Object as () => any,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showErrorModal: true,
      loading: true,
      content: false,
      tokenModal: false,
    };
  },
  computed: {
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
  },
  methods: {
    performAction(action) {
      this.$emit('closeModal');
      action();
    },
    openTokenModal() {
      this.showErrorModal = false;
      this.tokenModal = true;
    },
    tokenReAuthCancel() {
      this.tokenModal = false;
      this.showErrorModal = true;
    },
    tokenCallbackMethod() {
      this.$emit('closeModal');
      // @ts-ignore
      this.params.tokenCallback();
    },
  },
  components: {
    TokenReAuth,
  },
});
